<template>
  <div class="done-screen">
    <div class="done-ic">
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#10B981"
        stroke-width="2.5"
        stroke-linecap="round"
      >
        <path d="m4 12.5 5 5L20 6.5" />
      </svg>
    </div>
    <h2>入驻申请已提交</h2>
    <p>预计 <b>1 个工作日</b>完成审核</p>
    <div class="done-track">
      <div>
        <span>资料提交</span>
        <span class="ok">✓ 已完成</span>
      </div>
      <div>
        <span>证件审核</span>
        <span class="ok">✓ 已通过</span>
      </div>
      <div>
        <span>平台人工审核</span>
        <span class="pri">● 预计 1 个工作日</span>
      </div>
      <div>
        <span>签约开通</span>
        <span class="muted">审核通过后开放</span>
      </div>
    </div>
    <div class="done-actions">
      <button
        type="button"
        class="btn btn-pri"
        style="height:44px;padding:0 24px"
        @click="$emit('home')"
      >
        返回首页
      </button>
    </div>
  </div>
</template>

<script>
import { getRegisterProgress } from "@/api/shipperRegisterH5";

export default {
  name: "DoneScreen",
  props: {
    phone: { type: String, default: "" }
  },
  computed: {
    maskPhone() {
      const p = this.phone || "";
      if (p.length < 7) return p;
      return p.slice(0, 3) + "****" + p.slice(-4);
    }
  },
  methods: {
    async onProgress() {
      try {
        await getRegisterProgress({ phone: this.phone });
        this.$message.info("进度查询接口待接入");
      } catch (e) {
        this.$message.error((e && e.message) || "查询失败");
      }
    }
  }
};
</script>

<style scoped>
.ok {
  color: var(--ok);
  font-weight: 600;
}
.pri {
  color: var(--b1);
  font-weight: 600;
}
.muted {
  color: var(--ink4);
}
.done-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}
@media (max-width: 640px) {
  .done-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .done-actions .btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
